import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'hr', name: 'Hrvatski', flagCode: 'hr' },
  { code: 'en', name: 'English', flagCode: 'gb' },
  { code: 'it', name: 'Italiano', flagCode: 'it' },
  { code: 'de', name: 'Deutsch', flagCode: 'de' }
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  // Zatvori dropdown kad klikneš izvan njega
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors border border-white/20"
        aria-label="Select language"
      >
        <span className={`fi fi-${currentLanguage.flagCode} text-base leading-none`}></span>
        <span className="text-sm font-medium text-white">{currentLanguage.code.toUpperCase()}</span>
        <svg 
          className={`w-4 h-4 text-white transition-transform ${isOpen ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full flex items-center gap-3 px-4 py-3 text-left transition-colors ${
                currentLanguage.code === lang.code
                  ? 'bg-[var(--color-primary)]/10 text-[var(--color-text-primary)] font-semibold'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <span className={`fi fi-${lang.flagCode} text-base`}></span>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <span className="text-sm">{lang.name}</span>
                  <span className="text-xs text-gray-500 font-mono">{lang.code.toUpperCase()}</span>
                </div>
              </div>
              {currentLanguage.code === lang.code && (
                <svg className="w-4 h-4 text-[var(--color-primary)]" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
